<!-- Original Code left for Compatablilty
<template>
  <div class="flex-layout" :class="['flex-layout-'+direction,inline&&'flex-layout-inline',center&&'flex-layout-center']">
    <slot />
  </div>
</template>
-->

<script>
export default {
  name: 'FlexLayout',
  functional: true, // Optimization, this component is Stateless
  props:{
    /** @type {'right'|'down'|'left'|'up'} (default:right) */
    direction: {
      type: String,
      default: 'right',
      validate: function(value){return ['right','down','left','up'].includes(value);}
    },
    inline:Boolean,
    center:Boolean,
    noWrap:Boolean,
    customGap:Boolean,
  },
  render:function(createElement,ctx){
    let classList = ['flex-layout','flex-layout-' + ctx.props.direction];
    if (ctx.props.inline)
      classList.push('flex-layout-inline');
    if (ctx.props.center)
      classList.push('flex-layout-center');
    if (ctx.props.noWrap)
      classList.push('flex-layout-nowrap');
    if(ctx.props.customGap !== true)
      classList.push('flex-layout-gap24');
    if(ctx.data.staticClass)
      classList.push(ctx.data.staticClass);

    return createElement('div',{'class':classList},ctx.children);
  },
}
</script>

<style>
.flex-layout {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
}
.flex-layout-gap24{
  gap: 24px;
}

.flex-layout-nowrap {
  flex-wrap: nowrap;
}

.flex-layout-inline {
  display: inline-flex;
  width: unset;
}

.flex-layout-right {
  flex-direction: row;
}

.flex-layout-left {
  flex-direction: row-reverse;
}

.flex-layout-down {
  flex-direction: column;
}

.flex-layout-up {
  flex-direction: column-reverse;
}
.flex-layout-center {
  align-items: center;
}

@media (max-width: 768px) {
  .flex-layout {
    gap: 16px;
    padding: 0;
  }
}
</style>
